import React from 'react'
import Table from '../../compopnents/table/indx';
import Styles from "./styles.module.scss";
import Button from '../../compopnents/button';
import Headline6 from "../../compopnents/headings/Headline6"; 
import { Icon } from '@iconify/react';
import Headline5 from '../../compopnents/headings/Headline5'


const  TimeSheetHistoryTab= (props: any) => {

  const approveTimeSheet = () => {
    props.clickHandler()
  }
  
  return (
    <>
    <div className="content-wrapper-box">
      <div className={Styles.basicHeadWrap}>
        <Headline6>Timesheet</Headline6>
        <button onClick={props.downloadButton} className={Styles.downloadButton}><Icon icon="ic:outline-file-download" /></button>
      </div>
      <Table type={'timeSheetHistory'} data={props.timesheetEntries}/>
      <div className={Styles.totalInfo}>
        <div className={Styles.cardItremWrap}>
          <div className={Styles.cardItrem}>
            <div className={Styles.form}>
              <label>Total working days in this month:</label>
              {props.timesheetDetails && props.timesheetDetails.total_working_days}
            </div>
            <div className={Styles.form}>
              <label>Actual working days:</label>
              {props.timesheetDetails && props.timesheetDetails.actual_working_days}
            </div>
          </div>
          <div className={Styles.cardItrem}>
            <div className={Styles.form}>
              <label>Holidays</label>
              {props.timesheetDetails && props.timesheetDetails.holidays}
            </div>
            <div className={Styles.form}>
              <label>Leaves: </label>
              {props.timesheetDetails && props.timesheetDetails.leaves}
            </div>
          </div>
          <div className={Styles.cardItrem}>
            <div className={Styles.form}>
              <label>Actual working hours:</label>
              <span className={Styles.total}>{props.timesheetDetails && props.timesheetDetails.actual_working_hours}</span>
            </div>
          </div>
        </div>
        <Button  onClick={() => props.setModalTrue()} type="submit" variant="reject">Reject</Button>
        { props.timesheet_status !== '3' && props.timesheet_status !== '4' &&<div className={Styles.totalaction}>
          <Button  onClick={() => props.setModalTrue()} type="submit" variant="reject">Reject</Button>
          <Button  onClick={() =>approveTimeSheet()} disabled={props.disable} type="submit" variant="primary">Approve</Button>
        </div>}   
      </div>  
    </div>
    <div className="content-wrapper-box mt-50">
      <Headline5>Timesheet History</Headline5>
      <Table type='checkHistory' data={props.historyData} timesheetHistory={true}/>   
    </div>
    </>
  )
}

export default TimeSheetHistoryTab